export enum FollowTypeEnum {
  USER = 'USER',
  PROJECT = 'PROJECT',
  EVENT = 'EVENT',
}
